import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { Building2 } from "lucide-react";

export default function CompanyInfo({ data }) {
    if (!data) return null;

    const { companyName, companyId, subscription, isInTrial, trialEndDate, limits } = data;

    const getPlanName = () => {
        if (limits.isUnlimited) return "Enterprise / Advanced";
        if (limits.monthlyLimit >= 100000) return "Build with You";
        if (limits.monthlyLimit >= 25000) return "Visionary";
        if (limits.monthlyLimit >= 10000) return "Innovator";
        if (limits.monthlyLimit >= 2000) return "Minimum";
        if (limits.monthlyLimit >= 500) return isInTrial ? "Trial (Starter-level)" : "Starter";
        return "Free / No Plan";
    };

    return (
        <Card>
            <CardHeader className="pb-3">
                <CardTitle className="flex items-center gap-2">
                    <Building2 className="h-5 w-5" />
                    Company
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-3">
                <div>
                    <p className="font-medium">{companyName}</p>
                    <p className="text-xs text-muted-foreground font-mono">{companyId}</p>
                </div>
                <div className="flex flex-wrap gap-2">
                    <Badge variant="outline">{getPlanName()}</Badge>
                    {subscription && <Badge variant="secondary">{subscription.status}</Badge>}
                    {isInTrial && (
                        <Badge variant="default" className="bg-blue-500">
                            Trial until {new Date(trialEndDate).toLocaleDateString()}
                        </Badge>
                    )}
                    {!subscription && !isInTrial && <Badge variant="destructive">No Access</Badge>}
                </div>
                <div className="grid grid-cols-3 gap-4 pt-2 border-t text-sm">
                    <div>
                        <p className="text-xs text-muted-foreground">Monthly Limit</p>
                        <p className="font-medium">
                            {limits.isUnlimited ? "Unlimited" : limits.monthlyLimit?.toLocaleString() || "0"}
                        </p>
                    </div>
                    <div>
                        <p className="text-xs text-muted-foreground">Grace Limit</p>
                        <p className="font-medium">
                            {limits.isUnlimited ? "—" : limits.graceLimit?.toLocaleString() || "0"}
                        </p>
                    </div>
                    <div>
                        <p className="text-xs text-muted-foreground">Max Concurrent</p>
                        <p className="font-medium">
                            {limits.isUnlimited ? "Unlimited" : limits.maxConcurrent || "0"}
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
